/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import ActionConstants from '../constants';
import { signupApi, salesForceAuthApi, edgeOnboardApi, emailVerification, resendVerificationMail, resetPasswordWithTokenApi } from '../../api/signup';

export const signupAction = (data) => {
  const payload = {
    serviceMethod: signupApi.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_SIGN_UP_SUCCESS,
    actionTypeFailure: ActionConstants.POST_SIGN_UP_FAILURE,
    actionTypeRequest: ActionConstants.POST_SIGN_UP_REQUEST,
    hideLoader: true,
    extra: {
      userEmail: data?.email,
    },
  };
  return { type: ActionConstants.POST_SIGN_UP_ACTION, payload };
};

export const emailVerificationAction = (data) => {
  const payload = {
    serviceMethod: emailVerification.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_EMAIL_VERIFICATION_SUCCESS,
    actionTypeFailure: ActionConstants.POST_EMAIL_VERIFICATION_FAILURE,
    actionTypeRequest: ActionConstants.POST_EMAIL_VERIFICATION_REQUEST,
    hideLoader: true,
  };
  return { type: ActionConstants.POST_EMAIL_VERIFICATION_ACTION, payload };
};

export const resendVerificationMailAction = (data) => {
  const payload = {
    serviceMethod: resendVerificationMail.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_RESEND_EMAIL_VERIFICATION_SUCCESS,
    actionTypeFailure: ActionConstants.POST_RESEND_EMAIL_VERIFICATION_FAILURE,
    actionTypeRequest: ActionConstants.POST_RESEND_EMAIL_VERIFICATION_REQUEST,
    hideLoader: true,
    extra:{
      token:data?.token
    },
  };
  return { type: ActionConstants.POST_RESEND_EMAIL_VERIFICATION_ACTION, payload };
};

export const edgeOnboardAction = (data,UATMID, authParams) => {
  const payload = {
    serviceMethod: edgeOnboardApi.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.EDGE_ONBOARD_SUCCESS,
    actionTypeFailure: ActionConstants.EDGE_ONBOARD_FAILURE,
    actionTypeRequest: ActionConstants.EDGE_ONBOARD_REQUEST,
    hideLoader: true,
    extra: {
      userEmail: data?.pluralleadrequest?.personalContactDetails?.contactPersonEmailId,
      UATMID,
    },
    loaderMessage: 'Hey , Please wait while we are setting up your UAT Account !!'
  };
  return { type: ActionConstants.EDGE_ONBOARD_ACTION, payload };
};

export const salesforceAuth = (data) => {
  const payload = {
    serviceMethod: salesForceAuthApi.bind(null, data),
    actionTypeSuccess: ActionConstants.SALESFORCE_AUTH_SUCCESS,
    actionTypeFailure: ActionConstants.SALESFORCE_AUTH_FAILURE,
    actionTypeRequest: ActionConstants.SALESFORCE_AUTH_REQUEST,
    hideLoader: true,
  };
  return { type: ActionConstants.SALESFORCE_AUTH_ACTION, payload };
};

export const clearSalesforceAuth = () => {
  return { type: ActionConstants.SALESFORCE_AUTH_CLEAR };
};

export const clearSignUpAction = () => {
  return { type: ActionConstants.POST_SIGN_UP_CLEAR };
};

export const clearEmailVerificationAction = () => {
  return { type: ActionConstants.POST_EMAIL_VERIFICATION_CLEAR };
};

export const clearResendEmailVerificationAction = () => {
  return { type: ActionConstants.POST_RESEND_EMAIL_VERIFICATION_CLEAR };
};

export const resetPasswordWithTokenAction = (data) => {
  const payload = {
    serviceMethod: resetPasswordWithTokenApi.bind(null, data),
    actionTypeSuccess: ActionConstants.RESET_PASSWORD_WITH_TOKEN_SUCCESS,
    actionTypeFailure: ActionConstants.RESET_PASSWORD_WITH_TOKEN_FAILURE,
    actionTypeRequest: ActionConstants.RESET_PASSWORD_WITH_TOKEN_REQUEST,
    hideLoader: true,
  };
  return { type: ActionConstants.RESET_PASSWORD_WITH_TOKEN, payload };
};

export const clearResetPasswordWithTokenAction = () => {
  return { type: ActionConstants.RESET_PASSWORD_WITH_TOKEN_CLEAR };
};
